/*
 * @Author: ziyongqiang
 * @Date: 2024-04-23 15:42:35
 * @LastEditors: ziyongqiang
 * @LastEditTime: 2024-04-23 15:53:39
 * @FilePath: \air-product\src\pages\APicturePage\APicturePageReq.ts
 * @Description:
 */
import { reactive, } from 'vue';
import { post, } from '@/request/request';
import axios from 'axios';

export const envStationList = reactive({
  country: [],
  province: [],
  city: [],
  micro: [],
  construction: [],
});
// 遍历获取站点数据 1:国控站,2：省控站,3：市控站,4：微站
// eslint-disable-next-line import/prefer-default-export
export const getCurrentbyType = (siteObj:any) => {
  const params = {
    stationType: siteObj.value,
  };

  post('/gaochun/airMap/airStationList',params).then((res:any) => res);
};

// 获取焦作行政边界geojson
export const getJiaoZuoArea = () => new Promise((resolve, reject) => {
  axios.get('./static/data/geojson/jiaozuo.geojson')
    .then((res) => {
      resolve(res);
    })
    .catch((err) => {
      reject(err.data);
    });
});
